import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2168ef64"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  href: "",
  target: "_blank",
  class: "course-card"
};
const _hoisted_2 = {
  class: "course"
};
const _hoisted_3 = {
  class: "course-img"
};
const _hoisted_4 = ["src"];

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "course-cover"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "course-messcore"
}, "学分 0"), /*#__PURE__*/_createElementVNode("span", {
  class: "course-line"
}), /*#__PURE__*/_createElementVNode("span", {
  class: "course-meshour"
}, "学时 0")], -1));

const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"course-content\" data-v-2168ef64><div data-v-2168ef64><div class=\"course-name text-overflow\" data-v-2168ef64> 计算机原理计算机原理计算机原理计算机原理计算机原理计算机原理 </div><div class=\"course-teacher text-overflow\" data-v-2168ef64> 1111111 <span data-v-2168ef64>·</span> 345 </div></div><div class=\"course-mes\" data-v-2168ef64><div data-v-2168ef64>累计选课 <span class=\"unit\" data-v-2168ef64>0</span><span data-v-2168ef64>人</span></div><div class=\"college-count\" data-v-2168ef64><span data-v-2168ef64>选课学校数 </span><span class=\"unit\" data-v-2168ef64>0</span><span data-v-2168ef64>所</span></div></div></div>", 1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("a", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: require('@/assets/images/common/course_cover.png')
  }, null, 8, _hoisted_4), _hoisted_5]), _hoisted_6])]);
}